/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/appCardList.config.json";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_EVENT_LIST } from "../graphql";
import { VApplication } from "../../../application";
import { BreadcrumbService } from "../../breadcrumbService";
import moment from 'moment';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const getBreadcrumbService = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.BreadcrumbService") as BreadcrumbService;
};

export interface IGetHolderGroupProps {
  offset?: number;
  size?: number;
  criteria?: any;
}

export interface IAppCardListMethods extends IPluginMethodMap {
  getAppCardListProps(args: any): Promise<any>;
}

export class AppCardListService implements IAgentPlugin {
  readonly methods: IAppCardListMethods;

  constructor() {
    this.methods = {
      getAppCardListProps: this.getAppCardListProps.bind(this),
    };
  }

  async getAppCardListProps(args: any) {
    const srv = getBreadcrumbService();
    const breadcrumbItems = srv?.getBreadCrumbItems();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log(`args in active events service`, args);
    let _where2:any = [];
    if(args?.criteria?.name){
      _where2.push({
        "column" : "stormName",
        "value" : [args?.criteria?.name],
        "op":"ContainsCI"
      });
    }
    try {
      if (client) {
        const res = await client.query({
          query: GET_EVENT_LIST,
          variables: {
            input: {
              skip: args?.offset ?? 0,
              limit: args?.size ?? 10,
              where:[
                {
                  "column": "status",
                  "value": ["ACTIVE","ACCEPTED","IN_QUEUE"],
                  "op": "In"
                },
                ..._where2
              ]
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data?.getListOfCyclone) {
          let _templateData = this.formatHolderGroup(
            res?.data?.getListOfCyclone?.data
          );
          return {
            appCardList: _templateData,
            isEmpty: res?.data?.getListOfCyclone?.data?.length <= 0,
            activePage: res?.data?.getListOfCyclone?.currentPage,
            pageSize: res?.data?.getListOfCyclone?.pageSize,
            totalCount: res?.data?.getListOfCyclone?.totalCount,
            totalPages: res?.data?.getListOfCyclone?.totalPages,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
    // return{
    //   config:{ ...config, ...(breadcrumbItems || {}) }
    // }
    // return { ...(config || {}) };
  }

  private formatHolderGroup(data: any) {
    console.log("formatHolderGroup =>", data);
    let _appCard = data.map((item: any) => {
      return {
        rowData:item,
        appCardId: item?.eventId,
        appCardImage: item?.logo ?? config?.logo,
        ribbon:{
          title:item?.status,
          backgroundColor:this.getStatusColor(item?.status)
        },
        appCardTitle: item?.stormName,
        appCardList:item?.payoutEstimate ? [{
          name:"Payout Estimate",
          value: item?.payoutEstimate
        }]:null,
        appCardDescription: item?.date ? moment(item?.date).format("LLL"): null,
      };
    });

    return _appCard;
  }

  private getStatusColor(status:string){
    switch(status){
      case "ACTIVE":
      return "#008640"
      case "ACCEPTED":
        return "#008640"
      case "PAID":
        return "#008640"
      case "IN_QUEUE": 
        return "#F0A901"
      default: return "#870000"
    }

  }
}
